import type { CreateApiUserResponse, GetApiUsersResponse } from '@/services/types';

import type { AccessLevel, ApiUser, CreatedApiUserResult } from './types';

export function mapAccessLevelToDomain(accessLevel: number): AccessLevel {
    switch (accessLevel) {
        case 1:
            return 'client';
        case 2:
            return 'location';
        case 3:
            return 'cage';
        default:
            return 'client';
    }
}

function mapGetApiUserResponseToDomain(apiUserResponse: GetApiUsersResponse): ApiUser {
    return {
        id: apiUserResponse.id,
        createdAt: new Date(apiUserResponse.createdAt),
        lastUsed: apiUserResponse.lastUsed ? new Date(apiUserResponse.lastUsed) : undefined,
        accessLevel: mapAccessLevelToDomain(apiUserResponse.accessLevel),
        allowedLocationIds: apiUserResponse.allowedLocationIds,
        allowedCageIds: apiUserResponse.allowedCageIds,
    };
}

export function mapGetApiUserResponsesToDomain(apiUserResponses: GetApiUsersResponse[]): ApiUser[] {
    return apiUserResponses.map(mapGetApiUserResponseToDomain);
}

export function mapCreateApiUserResponseToDomain(
    createApiUserResponse: CreateApiUserResponse
): CreatedApiUserResult {
    return {
        id: createApiUserResponse.id,
        createdAt: new Date(createApiUserResponse.createdAt),
        lastUsed: createApiUserResponse.lastUsed
            ? new Date(createApiUserResponse.lastUsed)
            : undefined,
        password: createApiUserResponse.password,
        accessLevel: mapAccessLevelToDomain(createApiUserResponse.accessLevelId),
        allowedLocationIds: createApiUserResponse.allowedLocationIds,
        allowedCageIds: createApiUserResponse.allowedCageIds,
    };
}
